<template>
	<div>
		<div class="clear"></div>
    	<div class="mb20 ad-4 mt20"><img src="../../static/images/footer-ad-1.png" width="1200" height="60"/></div>
	</div>
</template>

<script>
	export default {
		name: 'footerslogan',
		data() {
			return {
				msg: 'Welcome to Your Vue.js App123'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/FooterSlogan.vue